import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { Card, CardHeader, Collapse } from 'reactstrap';
import NumberFormat from 'react-currency-format';

const column1 = [
  {
    Header: 'Award Date',
    accessor: 'awardDate',
  },
  {
    Header: 'Contract Number',
    accessor: 'contractNumber',
  },
  {
    Header: 'NIIN',
    accessor: 'niin',
  },
  {
    Header: 'CAGE',
    accessor: 'cage',
  },
  {
    Header: 'Company Name',
    accessor: 'companyName',
  },
  {
    Header: 'Quantity',
    accessor: 'awardQuantity',
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    Cell: cellProps => (
      <NumberFormat
        value={cellProps.original.unitPrice || '-'}
        displayType="text"
        thousandSeparator=","
        prefix="$"
      />
    ),
  },
  {
    Header: 'Total Value',
    accessor: 'totalValue',
    Cell: cellProps => (
      <NumberFormat
        value={cellProps.original.totalValue || '-'}
        displayType="text"
        thousandSeparator=","
        prefix="$"
      />
    ),
  },
];

const Header = data => {
  const [toggleQuestion, setToggequestion] = useState(1);

  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          Search Summary {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>

        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={data.block}
            columns={column1}
            defaultPageSize={data.block.length > 0 ? data.block.length : 3}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
      </Card>
      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/historyTables/ProcurementSearch.jsx